<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useI18n } from 'vue-i18n'

defineProps<{
  isOpen: boolean
  searchLabels: string[]
  searchCount: number
}>()

const emit = defineEmits<{
  close: []
  confirm: []
}>()

const { t } = useI18n()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      @click.self="emit('close')">
      <div
        role="dialog"
        aria-modal="true"
        class="relative w-full max-w-lg rounded-none bg-white p-8 shadow-xl"
        @click.stop>
        <button
          type="button"
          class="absolute right-6 top-6 text-gray-400 hover:text-black"
          :aria-label="t('dashboard.pdf_modal.cancel')"
          @click="emit('close')">
          <XMarkIcon class="h-5 w-5" aria-hidden="true" />
        </button>

        <h3 class="pr-10 text-left text-lg font-semibold text-black">
          {{ t('dashboard.pdf_modal.title') }}
        </h3>

        <p class="mt-2 text-left text-sm font-medium leading-relaxed text-gray-600">
          {{ t('dashboard.pdf_modal.description', { count: searchCount }) }}
        </p>

        <ul
          v-if="searchLabels.length"
          class="mt-4 max-h-40 space-y-2 overflow-y-auto rounded-none bg-gray-2 p-4 text-left text-sm text-black">
          <li v-for="(label, index) in searchLabels" :key="`${label}-${index}`" class="truncate">
            {{ label }}
          </li>
        </ul>

        <div class="mt-8 flex items-center justify-end gap-3">
          <button
            type="button"
            class="rounded-none border border-stroke bg-white px-5 py-3 text-sm font-medium text-black hover:bg-gray-2"
            @click="emit('close')">
            {{ t('dashboard.pdf_modal.cancel') }}
          </button>
          <button
            type="button"
            class="rounded-none bg-green-dark px-5 py-3 text-sm font-medium text-white hover:bg-emerald-600"
            @click="emit('confirm')">
            {{ t('dashboard.pdf_modal.confirm') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
